import { render, staticRenderFns } from "./FontDemo.vue?vue&type=template&id=3e33f176&scoped=true&"
import script from "./FontDemo.vue?vue&type=script&lang=js&"
export * from "./FontDemo.vue?vue&type=script&lang=js&"
import style0 from "./FontDemo.vue?vue&type=style&index=0&id=3e33f176&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e33f176",
  null
  
)

export default component.exports